/* eslint-disable max-len */
import { Alert, Box, Typography } from "@mui/material";
import ContainerPainel from "components/container_painel";
import CardFormularioStatus from "components/forms/CardFormularioStatus";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFormulariosStore } from "stores/forms/formularios.store";

export default function PacoteFormulariosVisualizar(): JSX.Element {
    const { uuid } = useParams();

    const { formularios, getFormulariosByUUID } = useFormulariosStore();

    useEffect(() => {
        if (uuid) {
            getFormulariosByUUID(uuid);
        }
    }, []);

    return (
        <ContainerPainel pagina='Gerenciar Formulários' showBackButton={true}>
            <Box
                display={'flex'}
                flexDirection={'column'}
                gap={2}
                alignItems={'center'}
                width={'100%'}
            >
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    gap={2}
                    maxWidth={'1400px'}
                    padding={6}
                    paddingTop={2}
                >
                    <Alert
                        severity='info'
                        sx={{ marginY: '2rem', backgroundColor: '#EAEFF9' }}
                    >
                        <Typography
                            variant='body2'
                            fontSize='16px'
                            textAlign='left'
                            lineHeight={1.5}
                        >
                            {`Para enviar o pacote de formulários ao Gerente Estadual, certifique-se de que todos os formulários estejam com o status 'Concluido'`}
                        </Typography>
                    </Alert>

                    <Box display={'grid'} gridTemplateColumns={'repeat(2, 1fr)'} gap={2}>
                        {formularios.map((formulario) => (
                            <CardFormularioStatus key={formulario.uuid} {...formulario} hideEditButton={true} />
                        ))}
                    </Box>
                </Box>
            </Box>
        </ContainerPainel>
    )
}
